import { useApiClient } from '@m43/core';
import { ElasticSearchResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { orderBy } from 'lodash';
import { TAB_QUERY_CACHE_TIME } from '../tabs/constants';
import { HoistedQueryProps } from './types';

export function useEventLogQuery(props: {
    eventId?: number;
    hoistedQueryProps?: HoistedQueryProps;
}) {
    const { eventId } = props;
    const apiClient = useApiClient();
    return useQuery(
        ['GetUserActionsForEvent', eventId] as const,
        ({ queryKey }) => {
            return apiClient
                .request<ElasticSearchResource.GetUserActionsForEvent>({
                    method: 'GET',
                    url: `elastic_search/user_actions/event/${queryKey[1]}/`,
                    params: {
                        format_values: true,
                    },
                })
                .then((data) => {
                    return data.data.data?.items.flatMap((event) => {
                        // Remove any events w/o an eventLogMessage
                        if (!event.eventLogMessage) {
                            return [];
                        }
                        return {
                            ...event,
                            // Sort the changeViews by display name
                            changeViews: orderBy(
                                event.changeViews,
                                ['displayName'],
                                ['asc']
                            ).flatMap((event) => {
                                const { displayName, oldValue, newValue } = event;
                                if (displayName && (oldValue || newValue)) {
                                    return event;
                                } else {
                                    // Remove any change view with no value associated
                                    return [];
                                }
                            }),
                        } as typeof event;
                    });
                });
        },
        {
            cacheTime: TAB_QUERY_CACHE_TIME,
            ...props.hoistedQueryProps,
        }
    );
}
